<template>
  <div 
    class="spectralis-main-view-wrapper"
    @wheel.prevent="wheel">
    <oct-slice-view
      class="off-center-canvas"
      :sliceSize="sliceSize"
      :fitSize="sliceFit"
      :img="sliceImg"
      :imgSize="sliceImgSize"
      :transform="transform"
      :octColorSettings="octColorSettings"
      :imgLoading="sliceImgLoading"
      :dataLoading="octDataLoading"
      :sliceEyeMarker="sliceCurrentEyeMarker"
      :imgNotFound="sliceImgNotFound"
      :showSegmentation="showSegmentation"
      :sliceInfo="sliceInfo"
      :layerData="sliceSegmentationLayerData"
      :isMeasuring="isMeasuring"
      :measureData="measureData"
      :realLocation="realLocation"
      :isInBounds="isInBounds"
      @measurementChanged="measurementChanged"/>
    <div class="spectralis-chart-wrapper" id="spectralis-chart-wrapper">
      <canvas-annotation
        v-if="!!sliceSegmentationThicknessData"
        :canvasSize="chartSize"
        :imgSize="chartSize"
        :annotation="thicknessChart"/>
      <canvas-annotation
        v-if="isMeasuring"
        class="off-center-canvas"
        :canvasSize="innerChartSize"
        :imgSize="innerChartSize"
        :annotation="innerChartSegmentationMeasurement"/>
      <v-progress-circular
        v-if="sliceSegmentationIsLoading"
        class="escalon-absolute-center"
        indeterminate/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import canvasAnnotation from "../../../canvas/components/CanvasAnnotation";
import ThicknessChart from "../../../canvas/annotations/thicknessChart";
import InnerChartSegmentationMeasurement from "../../../canvas/annotations/innerChartSegmentationMeasurement";
import octSliceView from "./OCTSliceView";
export default {
  name: "spectralisMainView",
  components: { canvasAnnotation, octSliceView },
  props: ["sliceSize", "sliceImgSize", "sliceFit", "transform", "chartSize", "realLocation", "isInBounds", "innerChartSize"],
  data() {
    return {
      thicknessChart: new ThicknessChart(),
      innerChartSegmentationMeasurement: new InnerChartSegmentationMeasurement()
    };
  },
  computed: {
    ...mapGetters([ "sliceImgNotFound", "sliceImgLoading", "currentEye", "hasWebgl", 
    "sliceImg", "octDataLoading", "octColorSettings", "sliceSegmentationThicknessData", 
    "sliceSegmentationIsLoading", "sliceInfo", "sliceSegmentationLayerData", 
    "showSegmentation", "isMeasuring", "measureData", 
    "sliceCurrentEyeMarker", "showSegmentation", "isMeasuring" ]),
    isLoading() {
      return this.sliceImgLoading || this.octDataLoading;
    }
  },
  methods: {
    measurementChanged(x) {
      this.$store.commit("setMeasurementIndex", x);
    },
    wheel(e) {
      if (e.deltaY > 0) this.$emit("previous");
      else this.$emit("next");
    },
  },
  watch: {
    transform: {
      handler() {
        this.thicknessChart.updateTransform(this.transform);
        this.innerChartSegmentationMeasurement.updateTransform(this.transform);
      },
      deep: true
    },
    sliceSegmentationThicknessData() {
      this.thicknessChart.updateData(this.sliceSegmentationThicknessData);
    },
    sliceFit() {
      this.thicknessChart.updateSliceFit(this.sliceFit);
    },
    chartSize() {
      this.thicknessChart.updateChartSize(this.chartSize);
    },
    sliceInfo: {
      handler() {
        this.thicknessChart.updateSliceInfo(this.sliceInfo);
        this.innerChartSegmentationMeasurement.updateSliceInfo(this.sliceInfo);
      },
      deep: true
    },
    measureData() {
      this.innerChartSegmentationMeasurement.updateMeasureData(
        this.measureData
      );
    }
  },
  mounted() {
    this.thicknessChart.updateChartSize(this.chartSize);
    this.thicknessChart.updateSliceFit(this.sliceFit);
    this.thicknessChart.updateTransform(this.transform);
    this.thicknessChart.updateSliceInfo(this.sliceInfo);
    this.thicknessChart.updateData(this.sliceSegmentationThicknessData);
    this.thicknessChart.fontColor = this.colorHex;
    this.thicknessChart.dataColor = this.colorHex;
    this.innerChartSegmentationMeasurement.updateMeasureData(this.measureData);
    this.innerChartSegmentationMeasurement.updateTransform(this.transform);
    this.innerChartSegmentationMeasurement.updateSliceInfo(this.sliceInfo);
  }
};
</script>
